// extracted by mini-css-extract-plugin
export default {"loadingContainer":"loadingContainer--WSmqU"};